import React from 'react'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import IconButton from '@material-ui/core/IconButton'
import { Field } from '../../form'
import FontAwesome from 'react-fontawesome'
import { GenericNumberInput } from '../../utils/numberFormat'
import { useDispatch } from 'react-redux'
import { getRegisteredUsersList } from '../../actions'

const styles = (theme) => ({
  invoiceUserEmail: {
    marginTop: theme.spacing(4),
    width: '300px'
  },
  textField: {
    marginTop: theme.spacing(4),
    border: '1px solid gray',
    minWidth: '300px'
  },
  resize: {
    fontSize: '14px'
  },
  groupInv: {
    marginTop: theme.spacing(4),
    border: '1px solid #44c0cc',
    borderRadius: '2px'
  },
  groupInvExpand: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      display: 'block'
    }
  },
  groupInvoiceItem: {
    paddingRight: '30px',
    [theme.breakpoints.down('md')]: {
      paddingRight: '0px'
    }
  }
})

const GroupInvoiceRow = ({
  t,
  classes,
  index,
  control,
  groupEmail,
  groupAmount,
  remove
}) => {
  const dispatch = useDispatch()
  return (
    <div>
      <div className={classes.groupInvExpand}>
        <div className={classes.groupInvoiceItem}>
          <Field
            name={groupEmail}
            label={
              index === 0
                ? null // Removed label1 here
                : `${t('groupInv.label3')} #${index}`
            }
            labelStyle={{ whiteSpace: 'nowrap' }}
            className={
              index === 0
                ? classNames(classes.invoiceUserEmail, classes.resize)
                : classNames(classes.textField, classes.resize)
            }
            inputType="textfield"
            control={control}
            disabled={index === 0}
            onChange={(e) => {
              if (
                index !== 0 &&
                /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(e.target.value)
              ) {
                dispatch(getRegisteredUsersList(e.target.value))
              }
            }}
            autoComplete="no"
          />
        </div>
        <div className={classes.groupInvoiceItem}>
          <Field
            name={groupAmount}
            label={
              index === 0
                ? t('groupInv.label2')
                : `${t('groupInv.label4')} #${index} ${t('groupInv.label4a')}`
            }
            className={classNames(classes.textField, classes.resize)}
            inputType="textfield"
            inputComponent={GenericNumberInput}
            control={control}
            style={{
              marginTop: '0px',
              paddingTop: '0px',
              paddingBottom: '0px'
            }}
          />
        </div>
        {index >= 2 && (
          <div>
            <IconButton
              style={{ marginTop: 30, float: 'right' }}
              aria-label="Delete"
              onClick={() => remove(index)}
              key={index}
            >
              <FontAwesome
                name="window-close"
                style={{
                  color: '#F67131'
                }}
              />
            </IconButton>
          </div>
        )}
      </div>
    </div>
  )
}

export default withStyles(styles)(GroupInvoiceRow)
